import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "operating-5",
  "use": "operating-5-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"operating-5\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 678.88c-184.36 0-333.79-57.33-333.79-149.49v93.86c0 92.17 149.44 166.87 333.79 166.87s333.72-74.7 333.72-166.87v-93.86c0.04 92.16-149.36 149.49-333.72 149.49z m0 166.87c-184.36 0-333.79-57.33-333.79-149.49v93.86C178.24 882.3 327.68 957 512 957s333.72-74.7 333.72-166.87v-93.86c0.04 92.15-149.36 149.49-333.72 149.49zM512 512c-184.36 0-333.79-57.32-333.79-149.49v93.87c0 92.16 149.44 166.87 333.79 166.87s333.72-74.72 333.72-166.87v-93.87C845.76 454.68 696.36 512 512 512z m0-445c-184.36 0-333.79 74.71-333.79 166.88v55.62c0 92.17 149.44 166.88 333.79 166.88s333.76-74.71 333.76-166.88v-55.62C845.76 141.71 696.36 67 512 67z\" fill=\"#29A1F7\" p-id=\"233192\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/operating-5.svg
// module id = VsfW
// module chunks = 38